<mat-toolbar color="accent">{{ dialogTitle }}</mat-toolbar>
<mat-dialog-content>
  <form
    class="flex flex-col"
    [formGroup]="attributionForm"
    (ngSubmit)="submit()"
  >
    <pr-staff-selector
      formControlName="staffer"
      [practice]="data.practice"
      [permissions]="permissions"
      [showNone]="true"
    />

    <pt-buttons-container padding="none">
      <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary">
        @if (isEdit) {
          Save
        } @else {
          Add
        }
      </button>
    </pt-buttons-container>
  </form>
</mat-dialog-content>
